import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, timer } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { CompromisedPasswordService } from '../services/compromised-password.service';
import { TrackingService } from '../../bdo/services/tracking.service';
import { TRACKING } from '../../bdo/enums/trackingParts.enum';
import { inject } from '@angular/core';

export function compromisedPasswordValidator(
  service: CompromisedPasswordService,
  translateService: TranslateService,
  trackingLocation: TRACKING.LOCATION
): AsyncValidatorFn {
  const trackingService = inject(TrackingService);
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null);
    }
    return timer(500).pipe(
      switchMap(() => service.isPasswordCompromised(control.value as string)),
      tap(isCompromised => {
        if (isCompromised) {
          trackingService.postTracking(trackingLocation, TRACKING.ACTION.COMPROMISED);
        }
      }),
      switchMap(isCompromised =>
        isCompromised ? of({ compromised: translateService.instant('register.error.compromisedPassword') }) : of(null)
      ),
      catchError(() => of(null))
    );
  };
}
